import ModalTemplate from "../../../../components/modal/modalTemplate";

const ImagePreviewModal = ({ show, imageSrc, onClose }) => {
    if (!imageSrc) return null;

    return (
        <ModalTemplate
            show={show}
            closeFun={onClose}
            centered
            // size="xl"
            backdrop="static"
            title="Image preview"
            body={
                <div className="text-center">
                    <img
                        src={imageSrc}
                        alt="preview"
                        style={{
                            maxWidth: "100%",
                            maxHeight: "75vh",
                            objectFit: "contain",
                            borderRadius: 8
                        }}
                    />
                </div>
            }
            footer={
                <button
                    className="btn btn-secondary btn-sm"
                    onClick={onClose}
                >
                    Close
                </button>
            }
        />
    );
};

export default ImagePreviewModal;